// client/src/pages/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// ✅ FIX: use production API URL
const BASE = process.env.REACT_APP_API_URL;

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${BASE}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Invalid login credentials");
        setLoading(false);
        return;
      }

      login(data.user, data.token);
      // alert("Login successful!");
      navigate("/home");

    } catch (err) {
      // alert("Server error");
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 dark:bg-slate-900 px-4 transition-colors">
      <div className="bg-white dark:bg-slate-800 shadow-xl rounded-2xl p-8 w-full max-w-md border border-slate-200 dark:border-slate-700">

        <h2 className="text-3xl font-bold text-center text-indigo-600 dark:text-indigo-400 mb-6">
          Login
        </h2>

        <form onSubmit={handleLogin} className="space-y-5">

          <div>
            <label className="block text-slate-700 dark:text-slate-200 font-semibold mb-1">
              Email
            </label>
            <input
              type="email"
              className="w-full border p-3 rounded-lg bg-white dark:bg-slate-700
              text-slate-900 dark:text-white border-slate-300 dark:border-slate-600
              focus:ring-2 focus:ring-indigo-500 outline-none transition"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-slate-700 dark:text-slate-200 font-semibold mb-1">
              Password
            </label>
            <input
              type="password"
              className="w-full border p-3 rounded-lg bg-white dark:bg-slate-700
              text-slate-900 dark:text-white border-slate-300 dark:border-slate-600
              focus:ring-2 focus:ring-indigo-500 outline-none transition"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 rounded-lg text-white text-lg font-semibold 
            bg-gradient-to-r from-indigo-600 to-purple-600 shadow-md hover:shadow-lg transition
            ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
          >
            {loading ? "Logging in…" : "Login"}
          </button>
        </form>

        <p className="text-center text-slate-600 dark:text-slate-400 mt-5">
          Don’t have an account?{" "}
          <span
            onClick={() => navigate("/register")}
            className="text-indigo-600 dark:text-indigo-400 cursor-pointer hover:underline"
          >
            Register here
          </span>
        </p>
      </div>
    </div>
  );
}
